<script lang="ts" setup>
import { computed, defineAsyncComponent } from 'vue';
import { RouterView, useRoute } from 'vue-router';
import { useHead } from '@unhead/vue';
import { PageHeader } from './components/page-header';
import { PageFooter } from './components/page-footer';
import RegFormDialog from './components/exam/reg-form-dialog.vue';
import LockConfirmDialog from './components/exam/lock-confirm-dialog.vue';

const route = useRoute();
const defaultTitle = '人才认证考试报名';
const routeTitle = computed(() => (typeof route.meta.title === 'string' ? route.meta.title : ''));

useHead({
  title: routeTitle,
  titleTemplate: (title) => {
    if (title) {
      return `${title} - ${defaultTitle}`;
    }

    return defaultTitle;
  },
});

const Toaster = defineAsyncComponent(() =>
  import('./components/ui/sonner').then(({ Toaster }) => Toaster),
);
</script>

<template>
  <div class="flex min-h-dvh flex-col">
    <PageHeader />

    <main class="flex-1">
      <RouterView v-slot="{ Component }">
        <Component :is="Component" />
      </RouterView>
    </main>

    <PageFooter />
  </div>

  <Toaster />

  <RegFormDialog />
  <LockConfirmDialog />
</template>
